import { render, staticRenderFns } from "./importPeriodoIndividual.vue?vue&type=template&id=4812e851&scoped=true"
import script from "./importPeriodoIndividual.vue?vue&type=script&lang=js"
export * from "./importPeriodoIndividual.vue?vue&type=script&lang=js"
import style0 from "./importPeriodoIndividual.vue?vue&type=style&index=0&id=4812e851&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4812e851",
  null
  
)

export default component.exports